import { NumericTextBox, TextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { FILTER_OPERATORS } from "../dialogs/DialogFilterExtended";

/**
 * Filtrovacia bunka pre cisla formatovane ako string (napr. pre ucely operatora IN)
 * @param {*} props 
 */
const CompactStringNumericFilterCell = (props) => {
  const { value, onChange, operator, field } = props;
  const operators = FILTER_OPERATORS["numeric"] || [];
  const operatorValue = (operators && operators.find((x) => x.operator === operator)) || operators[0];

  const handleOperatorChange = (e) => {
    let newValue = value;
    if ((operator === "in" || operator === "notin") && (e.target.value.operator !== "in" || e.target.value.operator !== "notin")) {
      newValue = null;
    }
    onChange({
      value: newValue,
      operator: e.target.value.operator,
      nativeEvent: e.nativeEvent,
      syntheticEvent: e.syntheticEvent,
    });
  };

  const handleChange = (event) => {
    if (/^(\d+[,.]?)*$/gm.test(event.value) || event.value === null) {
      onChange({
        value: event.value,
        operator: operator ? operator : "eq",
        nativeEvent: event.nativeEvent,
        syntheticEvent: event.syntheticEvent,
      });
    }
  };

  return (
    <div className="k-filter-menu-container">
      <DropDownList data={operators} textField={"text"} value={operatorValue} onChange={handleOperatorChange} />
      {(operator === "in" || operator === "notin") ?
        <TextBox
          name={field}
          onChange={handleChange}
          value={value || ""}
        />
        :
        <NumericTextBox
          name={field}
          onChange={handleChange}
          value={value || ""}
        />
      }
    </div>
  );
}

export default CompactStringNumericFilterCell;